import { render, staticRenderFns } from "./repair_detail.vue?vue&type=template&id=0d32885a&scoped=true&"
import script from "./repair_detail.vue?vue&type=script&lang=js&"
export * from "./repair_detail.vue?vue&type=script&lang=js&"
import style0 from "./repair_detail.vue?vue&type=style&index=0&id=0d32885a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d32885a",
  null
  
)

export default component.exports